import { Deserializable } from '../protocols/deserializable';

export class DefinedContributionAccountDetails implements Deserializable {
  public lastContributionAmount!: number;
  public lastContributionDate!: string | null;

  public onDeserialize(): void {}
}
